import { render, staticRenderFns } from "./newOaWorkflowForm.vue?vue&type=template&id=1cfe3932&scoped=true"
import script from "./newOaWorkflowForm.vue?vue&type=script&lang=js"
export * from "./newOaWorkflowForm.vue?vue&type=script&lang=js"
import style0 from "./newOaWorkflowForm.vue?vue&type=style&index=0&id=1cfe3932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfe3932",
  null
  
)

export default component.exports